<template>
  <vuescroll>
      <div id="profile" class="box-border relative bg-center bg-cover bg-gradient-profile">
        <div id="img-profile" class="absolute top-0 left-0 w-full h-full">
          <div id="profile-details" class="absolute bottom-0 left-0 z-10 w-full pb-2 text-center">
            <div id="profile-name" class="mb-1 text-lg uppercase">
              <span class="font-bold tracking-wider">{{ profile.name }}</span>
              <span>{{ profile.surnames }}</span>
            </div>
            <div id="profile-more">
              <span
                class="px-2 py-1 text-xs font-bold tracking-wider uppercase rounded-full bg-tertiary"
              >{{ profile.job }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="box-border block h-full">
        <div id="description" class="p-4">
          {{ profile.description }}
        </div>
      </div>
  </vuescroll>
</template>

<script>
import profile from '../data/profile'
import vuescroll from "vuescroll";

export default {
  name: "Profile",
  components: { vuescroll },
  data() {
    return {
      profile: profile
    }
  }
};
</script>
